import { render, staticRenderFns } from "./CustomerClient.vue?vue&type=template&id=e8b8911c&scoped=true&"
import script from "./CustomerClient.vue?vue&type=script&lang=js&"
export * from "./CustomerClient.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClient.vue?vue&type=style&index=0&id=e8b8911c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b8911c",
  null
  
)

export default component.exports